<div id="needTopUp" class="alert alert-danger" role="alert">
    {{'Your token quota is over, to continue scanning you have'| i18n}}
    <a href="/user" class="alert-link">
        {{'to buy new tokens'| i18n}}
    </a>
</div>